import { GetRequestsList, CreateRequest, DeleteRequest, UpdateRequest } from '../requests/StepInRequests';

export const getRequestList = async () => {
	try {
		const response = await GetRequestsList(); // Faz a requisição
		return response.data; // Retorna apenas os dados
	} catch (error) {
		console.error('Error fetching requests:', error);
		throw error; // Lança o erro para ser tratado no componente
	}
};

export const deleteRequestAction = async (userId, name) => {
	try {
		const response = await DeleteRequest(userId, name); // Chama a requisição
		return response.data; // Retorna a resposta para o componente
	} catch (error) {
		console.error('Error deleting request:', error);
		throw error; // Lança o erro para ser tratado
	}
};

export const updateRequestAction = async (dto) => {
	try {
		const response = await UpdateRequest(dto); // Chama a requisição
		return response.data; // Retorna a resposta para o componente
	} catch (error) {
		console.error('Error updating request:', error);
		throw error; // Lança o erro para ser tratado
	}
};

export const createRequestAction = async (dto) => {
	try {
		const response = await CreateRequest(dto); // Chama a requisição
		return response.data; // Retorna a resposta para o componente
	} catch (error) {
		console.error('Error creating request:', error);
		throw error; // Lança o erro para ser tratado
	}
};